import { computed, inject, Injectable } from '@angular/core';

import { CapabilitiesRepository } from '@data/repositories';
import { Command } from '@domain/helpers';
import { CapabilitiesStore, TCapabilitiesFiltersStore } from '@core/stores';
import { TCapabilitiesFiltersMonth } from '../../domain/types';

@Injectable({
  providedIn: 'root',
})
export class CapabilitiesChartFacade {
  private readonly capabilityReponsitory = inject(CapabilitiesRepository);
  private readonly store = inject(CapabilitiesStore);

  readonly monthlyCapabilities = new Command(
    (params: TCapabilitiesFiltersStore) =>
      this._listCapabilitiesMonthly(params),
  );

  readonly data = computed(() => this.monthlyCapabilities.data() || []);

  private async _listCapabilitiesMonthly(params: TCapabilitiesFiltersStore) {
    this.store.setFilters(params);

    const filters: TCapabilitiesFiltersMonth = {
      filial: params.filial,
      operation: params.operation,
      month: params.date.toFormat('yyyy-MM'),
    };

    const result =
      await this.capabilityReponsitory.getCapabilitiesMonthlyChart(filters);

    return result;
  }
}
